var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 600,
        visible: _vm.visible,
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        okText: this.$store.getters.language["common.okButton"],
        cancelText: this.$store.getters.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["application"]
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        allowClear: "",
                        disabled:
                          _vm.$store.getters.application.applicationType !=
                          "platform"
                      },
                      model: {
                        value: _vm.model.applicationCode,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "applicationCode", $$v)
                        },
                        expression: "model.applicationCode"
                      }
                    },
                    _vm._l(_vm.allApplications, function(item, index) {
                      return _c(
                        "a-select-option",
                        {
                          key: index.toString(),
                          attrs: { value: item.applicationCode }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.applicationNameLanguage) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "dictName",
                    required: "",
                    label: _vm.language["sys.dictfunc.dictName"]
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["sys.dictfunc.dictName"]
                    },
                    model: {
                      value: _vm.model.dictName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "dictName", $$v)
                      },
                      expression: "model.dictName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "dictCode",
                    required: "",
                    label: _vm.language["sys.dictfunc.dictCode"]
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["sys.dictfunc.dictCode"]
                    },
                    model: {
                      value: _vm.model.dictCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "dictCode", $$v)
                      },
                      expression: "model.dictCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["common.desc"]
                  }
                },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.model.description,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }